import { render, staticRenderFns } from "./teilnahmebedingungen.vue?vue&type=template&id=2cefe65c&lang=pug"
import script from "./teilnahmebedingungen.vue?vue&type=script&lang=js"
export * from "./teilnahmebedingungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
